import { createSelector } from "@ngrx/store";

import { CalendarEvent_LocationFragment } from "../../../../../../generated/graphql.generated";

import { getResourceChanges } from "../../../../job-helpers";
import { selectEventToBook } from "../timeline-book-event.selectors";

import { eventItineraryFeature } from "./event-itinerary.feature";

export const selectCanSaveLocations = createSelector(
  eventItineraryFeature.selectEventItinerary,
  ({ locations }) => Object.values(locations).every((location) => location.location?.id),
);

export const selectLocationsOrderChanged = createSelector(
  eventItineraryFeature.selectEventItinerary,
  selectEventToBook,
  (itinerary, event) => {

    if (!event) { return false; }

    const locations = Object.values(itinerary.locations);

    const { edited: editLocations, added, removed } = getResourceChanges<CalendarEvent_LocationFragment>({
      original: event.locations || [],
      modified: locations.map((l) => ({ ...l, type: l.locationType })),
      keyExtractor: (item) => `${item.type}-${item.id}`,
      compareFn: (original, modified) => original.order === modified.order,
      detectEdited: true
    });

    return editLocations.length > 0 || added.length > 0 || removed.length > 0;
  }
);
